import { render, staticRenderFns } from "./Auth0Callback.vue?vue&type=template&id=538b3a35&"
import script from "./Auth0Callback.vue?vue&type=script&lang=js&"
export * from "./Auth0Callback.vue?vue&type=script&lang=js&"
import style0 from "./Auth0Callback.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports